import { AuthService } from '@/Services/auth.service';
import { Component, computed, inject } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer text-gray-500 flex-col p-0 m-0 gap-0">
        <span class="text-1 leading-none">Inviare by <a href="https://syspotec.com" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Syspotec S.A.S</a></span>
    </div>`
})
export class AppFooterComponent {
    authService = inject(AuthService);
}
